import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';
import { colorPaletteTheme } from '@/utility/theme/color';

export const H2 = styled.h2(() =>
  mq({
    fontSize: defaultTheme.font.size.l,
    fontWeight: 'bold',
    borderBottom: `1px solid ${defaultTheme.border.color.darkGray}`,
    paddingBottom: defaultTheme.spacing.m,
    margin: `32px 0 ${defaultTheme.spacing.m}`,
  }),
);

export const H3 = styled.h3(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    fontWeight: 'bold',
    margin: `${defaultTheme.spacing.s} 0 ${defaultTheme.spacing.l}`,
  }),
);

export const Anchor = styled.a((props: { style?: React.CSSProperties }) =>
  mq({
    textDecorationLine: 'underline',
    color: colorPaletteTheme.blueLink,
    ...hoverOpacity,
    ...props.style,
  }),
);

export const ButtonWrapper = styled.span(() =>
  mq({
    display: 'block',
    maxWidth: '320px',
    width: ['100%', '100%', '320px', '320px'],
    height: '56px',
    margin: '40px auto',
  }),
);

export const StyledLink = styled(Anchor)().withComponent(Link);

export const ImageWrapper = styled.div(() =>
  mq({
    width: ['100%', '100%', '480px', '480px'],
    margin: '0 auto',
  }),
);

export const IframeWrapper = styled.div(() =>
  mq({
    position: 'relative',
    width: ['100%', '100%', '480px', '480px'],
    height: 0,
    paddingTop: '75%',
    margin: '0 auto',
    '& > iframe': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: ['100%', '100%', '480px', '480px'],
      height: ['100%', '100%', '360px', '360px'],
    },
  }),
);

export const Ul = styled.ul(() =>
  mq({
    listStyle: 'inside',
    lineHeight: 1.6,
  }),
);

export const Blockquote = styled.blockquote(() => mq({}));

export const MediaWrapper = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  }),
);
